import { createApiSlice } from "@common";
import {
  CRUD_OPPORTUNITY_QUALIFICATION,
  GET_OPPORTUNITY_QUALIFICATION_BY_OPPORTUNITY_ID,
} from "@routes";

const apiConfig = [
  {
    name: "addOpportunityQualification",
    method: "post",
    url: CRUD_OPPORTUNITY_QUALIFICATION,
    stateKey: "message",
  },
  {
    name: "getOpportunityQualificationByOpportunityId",
    method: "get",
    url: GET_OPPORTUNITY_QUALIFICATION_BY_OPPORTUNITY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "opportunityQualification",
  apiConfig,
  customReducers
);
const opportunityQualificationSlice = slice;

export default opportunityQualificationSlice.reducer;

export const {
  addOpportunityQualification,
  getOpportunityQualificationByOpportunityId,
} = thunks;

export const { rowSelect } = actions;
